module.exports = __webpack_public_path__ + "img/yl3062.c96d639e.png";